import { DatePipe } from '@angular/common';
import { noUndefined } from '@angular/compiler/src/util';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { async } from '@angular/core/testing';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirecFormService } from 'src/app/services/redirec-form.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';
import { lastValueFrom } from 'rxjs';

import * as alertifyjs from 'alertifyjs';
import { SocketioService } from 'src/app/services/socket/socketio.service';
import Swal from'sweetalert2';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FeeService } from 'src/app/services/fee.service';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-person-fee-payments',
  templateUrl: './person-fee-payments.component.html',
  styleUrls: ['./person-fee-payments.component.css', './fee-card-modern.css'],
  providers: [DatePipe]

})
export class PersonFeePaymentsComponent implements OnInit {

  queryParams: any;
  person: any;
  section_transactions: any = [];
  transaction: any = {};
  section_transaction: any;
  loading_person = false;
  loading = false;

  buro_response: any;
  buro: any;
  buro_score: any;
  activatePsico: any;
  showActivatePsico: any;

  loading_buro = false;
  psicometrico: any;
  psicometrico_response: any;
  psicometrico_array: any = [];
  status_approved: any;
   type_approved: any;
   clientQuota:any;
   invoiceCredits: any = [];
   resp_paymentsCredits: any = [];
   installments: any = [];
  // Filtros y datos para fees de persona (Fee_person)
  filterType: 'all' | 'installment' | 'person' = 'all';
  filterStatus: 'pending' | 'completed' | 'disabled' = 'pending';
  personFees: any[] = [];
  // Estadísticas para tarjetas de filtro
  stats = {
    allCount: 0,
    instCount: 0,
    instPending: 0,
    instDueTotal: 0,
    personCount: 0,
    personPending: 0,
    personDueTotal: 0
  };
  statusStats = {
    pendingCount: 0,
    completedCount: 0,
    disabledCount: 0,
    awaitingCloseCount: 0
  };

  getFeeVisualStatus(fee: any): 'complete' | 'awaiting-close' | 'pending' | 'inactive' {
    const code = fee?.payment_status?.code;
    const dueBalance = Number(fee?.due_balance ?? 0);
    if (code === 'PaymentInactivo' || fee?.manual_deleted || fee?.deleted_at) return 'inactive';
    if (code === 'PaymentComplete' || code === 'COM') return 'complete';
    if ((code === 'PaymentPending' || code === 'PEN') && dueBalance <= 0 && !fee?.exonerated) return 'awaiting-close';
    return 'pending';
  }
  // Banner: penalidad de persona pendiente para reactivación
  pendingPersonDueTotal: number = 0;
  hasPendingPersonFees: boolean = false;
  // Botón para generar fee de reactivación en Penalidades
  canShowReactivationButton: boolean = false;
  // Configuración del fee de reactivación
  reactivationFeeConfig: any = null;

   autopago: any = [{key: "BDV", name: "AUTO: BANCO DE VENEZUELA"},{key: "BA", name: "AUTO: BANCAAMIGA"}, {key: "MERCHANT", name: "AUTO: MEGASOFT"}, {key: "MC", name: "AUTO: MERCANTIL"}];
   banks: any;


view = 1;
invoiceSelected:any;
installMentSelected:any;
payment:any;
loadcon:any;
loadcon2:any;
subStatus:any = {};
submit_disabled_changeSubStatus: any;
list_payment_sub_status:any;

params_payment:any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    private redirecFormService: RedirecFormService,
    private datePipe: DatePipe,
    public socketService: SocketioService,
    public _auth : AuthService,
    private feeService: FeeService,
    private offcanvasService: NgbOffcanvas


  ) { }

  ngOnInit(): void {

    this.activatedRoute.params.subscribe(params => {
      this.queryParams = params;
      if (this.queryParams?.code) {

        this.getPerson();
        this.getBanks();
        this.loadReactivationFeeConfig();
      }

    });
    this.getpayment_sub_status();


  }

  // Cargar configuración del fee de reactivación
  async loadReactivationFeeConfig() {
    try {
      const resp: any = await this._user.getFees({ code_concept: 'C004' });
      if (resp?.success && resp?.data?.length > 0) {
        this.reactivationFeeConfig = resp.data[0];
        console.log('✅ Fee de reactivación cargado:', this.reactivationFeeConfig);
      } else {
        this.reactivationFeeConfig = null;
        console.log('⚠️ No se encontró configuración de fee de reactivación (C004)');
      }
    } catch (error) {
      console.error('❌ Error cargando configuración de fee de reactivación:', error);
      this.reactivationFeeConfig = null;
    }
  }

  private computeStats() {
    try {
      const installments = this.resp_paymentsCredits || [];
      const persons = this.personFees || [];

      const instPendingList = installments.filter((r: any) => r?.payment_status?.code === 'PaymentPending');
      const personPendingList = persons.filter((p: any) => (p?.manual_deleted !== true) && (p?.payment_status?.code === 'PaymentPending'));
      const personPendingC004 = persons.filter((p: any) => (p?.manual_deleted !== true) && (p?.payment_status?.code === 'PaymentPending') && (p?.fee?.concept_deduction?.code_concept === 'C004'));

      const instDueTotal = installments.reduce((sum: number, r: any) => sum + (Number(r?.due_balance) || 0), 0);
      const personDueTotal = persons.reduce((sum: number, p: any) => sum + (Number(p?.due_balance) || 0), 0);

      this.stats.instCount = installments.length;
      this.stats.instPending = instPendingList.length;
      this.stats.instDueTotal = instDueTotal;
      this.stats.personCount = persons.length;
      this.stats.personPending = personPendingList.length;
      this.stats.personDueTotal = personDueTotal;
      this.stats.allCount = this.stats.instCount + this.stats.personCount;

      // Banner: total pendiente de fees de persona
      this.pendingPersonDueTotal = personPendingList.reduce((sum: number, p: any) => sum + (Number(p?.due_balance) || 0), 0);
      this.hasPendingPersonFees = this.pendingPersonDueTotal > 0;
      // Mostrar botón solo si cliente inactivo y NO hay C004 pendiente
      this.canShowReactivationButton = (!this.person?.person?.quota_active) && (personPendingC004.length === 0);

      // Calcular estadísticas por estatus (combinando installments y persons)
      const allFees = [...installments, ...persons];
      const visualStatuses = allFees.map((f: any) => this.getFeeVisualStatus(f));
      this.statusStats.pendingCount = visualStatuses.filter(s => s === 'pending').length;
      this.statusStats.awaitingCloseCount = visualStatuses.filter(s => s === 'awaiting-close').length;
      this.statusStats.completedCount = visualStatuses.filter(s => s === 'complete' || s === 'awaiting-close').length;
      this.statusStats.disabledCount = visualStatuses.filter(s => s === 'inactive').length;
    } catch (e) {
      console.error('computeStats error:', e);
      this.stats = {
        allCount: 0, instCount: 0, instPending: 0, instDueTotal: 0,
        personCount: 0, personPending: 0, personDueTotal: 0
      };
      this.statusStats = {
        pendingCount: 0,
        completedCount: 0,
        disabledCount: 0,
        awaitingCloseCount: 0
      };
      this.pendingPersonDueTotal = 0;
      this.hasPendingPersonFees = false;
      this.canShowReactivationButton = false;
    }
  }

  // Generar fee de reactivación desde Penalidades
  async generateReactivationFeeFromFees() {
    try {
      console.log('🔍 [DEBUG] canShowReactivationButton:', this.canShowReactivationButton);
      console.log('🔍 [DEBUG] person:', this.person);
      console.log('🔍 [DEBUG] personId:', this.person?.person?._id);
      
      if (!this.canShowReactivationButton) {
        console.warn('⚠️ Botón no habilitado, saliendo...');
        return;
      }
      const personId = this.person?.person?._id;
      if (!personId) {
        console.warn('⚠️ No hay personId, saliendo...');
        return;
      }

      const result = await Swal.fire({
        title: '¿Generar Fee de Reactivación?',
        text: 'Se generará la penalidad de reactivación para este cliente.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, generar',
        cancelButtonText: 'Cancelar'
      });
      if (!result.isConfirmed) return;

      Swal.fire({
        title: 'Generando...',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      console.log('📞 Llamando a applyReactivationFee con personId:', personId);
      const observable = (this._user as any).applyReactivationFee(personId);
      const resp: any = await lastValueFrom(observable);
      console.log('📥 Respuesta del backend:', resp);
      Swal.close();

      if (resp?.success) {
        await Swal.fire({ title: 'Generado', icon: 'success', confirmButtonText: 'OK' });
        await this.getPerson();
      } else {
        const msg = resp?.error || resp?.message || 'No se pudo generar el fee de reactivación';
        console.error('❌ Error del backend:', msg, resp);
        await Swal.fire({ title: 'Error', text: msg, icon: 'error' });
      }
    } catch (e: any) {
      console.error('❌ Excepción capturada:', e);
      Swal.close();
      await Swal.fire({ title: 'Error', text: e?.message || 'Fallo generando el fee', icon: 'error' });
    }
  }

  // Ir a pago con el cliente seleccionado (monto visible en banner)
  goToPayPendingPersonFees() {
    try {
      const codePerson = this.person?.person?.code;
      if (!codePerson) return;
      // Navegar al flujo de pago por persona (sin alterar lógica existente)
      this.router.navigate(['/console/post/person', codePerson]);
    } catch (e) {
      console.error('goToPayPendingPersonFees error:', e);
    }
  }




  cancelPayment = async (payment:any) => {


    let action = 'Anular'

    Swal.fire({
      title: "¿Deseas Anular este pago?",
      text: "¡No podrás revertir esto!",
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      input: "select",
      inputOptions: {
        
        'No se encuentra en banco': 'No se encuentra en banco',
        'Pago duplicado': 'Pago duplicado',
        'Txs verificada por Merchant': 'Txs verificada por Merchant',
        'Txs verificada manualmente': 'Txs verificada manualmente',

      },
      inputPlaceholder: 'Selecciona una razón',
      showCancelButton: true,
      confirmButtonText: `Si, ${action}!`,
      showLoaderOnConfirm: true,
      preConfirm: async (reason) => {
        try {
          if (!reason) {
            return Swal.showValidationMessage(`Debe seleccionar una razón de anulación`);
          }
        } catch (error) {
          Swal.showValidationMessage(`Request failed: ${error}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        this.cancelPaymentQuestion(payment, result.value);
      }
    });

  }


  cancelPaymentQuestion = async (payment:any,msg = '') => {

    this.loadcon2 = true;
    try {

      const resp = await this._user.cancelPayment({ code_payment: payment,description:msg });


      if(this.subStatus[payment] == 'REVISION'){
        this.changeSubStatus(payment,'NA')

      }
      const resp_paymentsCredits = await this.listClientPaymentsCredits();
      this.resp_paymentsCredits = resp_paymentsCredits;


      if(resp?.res){

        alertifyjs.success(`Pago anulado codigo ${payment}`);
        this.getPerson();

      }

      this.loadcon2 = false;

    } catch (error) {
      console.error(error);

    this.loadcon2 = false;
  }

    this.loading_person = false;

  }


  getPerson = async () => {
    this.loading_person = true;
    try {

      const resp = await this._user.getPersonbyCode({ code: this.queryParams.code });
      this.person = resp.resp;

      const resp_paymentsCredits = await this.listClientPaymentsCredits();
      console.log(resp_paymentsCredits);
      for(let lcp of resp_paymentsCredits) {
        lcp.totalpaymentReference = 0;
        if(lcp?.paymentsFeeReferences) {
          lcp.totalpaymentReference = lcp?.paymentsFeeReferences?.reduce((acc: any, curr: any) => acc + curr.payment.amount, 0);
        }
        lcp.due_balance = lcp.due_balance - lcp.totalpaymentReference;
      }

      //payment_sub_status
      this.resp_paymentsCredits = resp_paymentsCredits;

      // Cargar fees de persona (Fee_installment)
      if (this.person?.person?.code) {
        try {
          // Cargar fees de installments (solo fees con installment) - usa personCode
          const personFeesResp = await this.feeService.getPersonFeesByCustomer(this.person.person.code, {});
          const installmentFees = personFeesResp?.data || [];
          
          // Cargar fees directos de persona (sin installment - como C004) - usa person._id
          const directFeesResp = await this.feeService.getPersonDirectFees(this.person.person._id);
          const directFees = directFeesResp?.data || [];
          
          // Combinar ambos resultados (sin duplicados)
          this.personFees = [...installmentFees, ...directFees];
          
          console.log('✅ Fees cargados:', {
            installmentFees: installmentFees.length,
            directFees: directFees.length,
            total: this.personFees.length
          });
        } catch (e) {
          console.error('Error cargando fees:', e);
          this.personFees = [];
        }
      }

      // Recalcular estadísticas para tarjetas de filtro
      this.computeStats();

    } catch (error) {
      console.error(error);

    }


    this.loading_person = false;


  }





  listClientPaymentsCredits = async () => {

    try {
        const data =  {
          personCode :this.queryParams?.code
        }

        return this.feeService.fees(data);

      } catch (error) {
        console.error(error);


      }
  }




  getIdentity(item: any) {

    if (!(item?.identitys?.length > 0))
      return "";

    return `${item?.identitys[0]?.type_identity?.name} ${item?.identitys[0]?.code_identity?.name}-${item?.identitys[0]?.identity}`;

  }


  getContact(item: any) {

    if (!(item?.constacts?.length > 0))
      return "";

    return `${item?.constacts[0]?.contact}`;


  }

  getEmailContact(item: any) {
    if (!(item?.constacts?.length > 0) || !item?.constacts[1]) return '';

    return `${item?.constacts[1]?.contact}`;
  }


  sanitize(url: string) {
    //return url;
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }


  redirectIMG(url:String){
    const link = `${url}`;
    window.open(link, '_blank');

}

findAutopago = (acron: string) => {
  console.log(acron);
  if(acron==="BA" || acron==="MC" || acron==="BDV") {
    let autopago = this.autopago.find((ele: any) => ele.key===acron);
    if(autopago) {
      return autopago.name;
    } else {
      return null;
    }
  } else {
    return acron
  }
}


getBanks = async () => {
  try {
    const resp = await this.getBanksServices();

    let banks_resp = resp?.res;
    let banks:any = {};


    banks_resp.map((value:any)=>{

      banks[value.bankCode] = value?.name;

    });

    this.banks = banks;


  } catch (error) {
    console.error(error);

  }

}


getBanksServices = async () => {
  return await this._user.getBanks({});
};


setPayment(data:any){


  let action = 'Editar'

  Swal.fire({
    title: `¿Deseas ${action} este pago?`,
    text: "¡No podrás revertir esto!",
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    input: "select",
    inputOptions: {
      'Banco Receptor errado': 'Banco Receptor errado',
      'Banco Emisor errado': 'Banco Emisor errado',
      'Número de referencia errado': 'Número de referencia errado',
      'Fecha de Pago errada': 'Fecha de Pago errada',
      'Monto errado': 'Monto errado',
      'Comprobante de pago errado': 'Comprobante de pago errado'
    },
    inputPlaceholder: 'Selecciona una razón',
    showCancelButton: true,
    confirmButtonText: `Si, ${action}!`,
    showLoaderOnConfirm: true,
    preConfirm: async (reason) => {
      try {
        if (!reason) {
          return Swal.showValidationMessage(`Debe seleccionar una razón de Edición`);
        }
      } catch (error) {
        Swal.showValidationMessage(`Request failed: ${error}`);
      }
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {
    if (result.isConfirmed) {
      data.description_edit = result?.value;
      localStorage.setItem('pe',JSON.stringify(data));
      this.router.navigate([`/console/post`], {});


    }
  });




}




changeSubStatus= async (code:any,code_sub:any) => {
  this.submit_disabled_changeSubStatus = true;


        let query = {
          code_payment: code,
          code_payment_sub_status:code_sub
        };

         await this._user.payment_sub_statusPost(query);
         this.subStatus[code] = code_sub;
        alertifyjs.success('Cambio exitoso');
        this.submit_disabled_changeSubStatus = false;


}







getpayment_sub_status = async () => {
try {

  const resp = await this.payment_sub_status();
  this.list_payment_sub_status = resp?.resp;

} catch (error) {
  console.error(error);

}




}


payment_sub_status = async () => {
try{
    return this._user.payment_sub_status({});

  } catch (error) {
    console.error(error);


  }
}



paymentRollback = async (payment:any) => {

let action = 'Revertir'

Swal.fire({
  title: `¿Deseas ${action} este pago?`,
  text: "¡No podrás revertir esto!",
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
  input: "select",
  inputOptions: {

    'No se encontro en banco': 'No se encontro en banco'

  },
  inputPlaceholder: 'Selecciona una razón',
  showCancelButton: true,
  confirmButtonText: `Si, ${action}!`,
  showLoaderOnConfirm: true,
  preConfirm: async (reason) => {
    try {
      if (!reason) {
        return Swal.showValidationMessage(`Debe seleccionar una razón`);
      }
    } catch (error) {
      Swal.showValidationMessage(`Request failed: ${error}`);
    }
  },
  allowOutsideClick: () => !Swal.isLoading()
}).then((result) => {
  if (result.isConfirmed) {

    this.servicePaymentRollback(payment, result.value);

  }
});
}


servicePaymentRollback = async (payment:any,msg = '') => {

  this.loadcon2 = true;

  try {

    const resp = await this._user.paymentRollback({ code_payment: payment,description:msg });

    const resp_paymentsCredits = await this.listClientPaymentsCredits();

    // let
    // this.resp_paymentsCredits?.paymentsFeeReferences?.map((value:any, index:any) => {

    //   this.totalpaymentReference = this.totalpaymentReference + value?.payment?.amount;
    //   return value;

    // });

    // totalpaymentReference
    this.resp_paymentsCredits = resp_paymentsCredits;




    if(resp?.res){
      this.getPerson();

      alertifyjs.success(`Pago devuelto `);

    }
    this.loadcon2 = false;

  } catch (error) {
    alertifyjs.error('Error al devolver pago estatus');

    console.error(error);

  this.loadcon2 = false;
}


  this.loading_person = false;


}

toDateFn(isoString: string): string {
  const [datePart, timePart] = isoString.split('T');
  const [year, month, day] = datePart.split('-');
  return `${day}/${month}/${year}`;
}


openBottom= async (content: TemplateRef<any>,params_invoice:any) => {
  try {
    console.log(params_invoice);

    this.params_payment = params_invoice;

    this.offcanvasService.open(content, {
      position: 'bottom',
      keyboard: false,

    });


  } catch (error) {
    console.log(error);
  }
};

response = (event: any) => {

}

// Verifica si se puede generar el fee de reactivación
canGenerateReactivationFee(): boolean {
  if (!this.person?.person) {
    console.log('🔍 canGenerateReactivationFee: No hay persona cargada');
    return false;
  }
  
  // Condiciones:
  // 1. El fee de reactivación (C004) debe existir en la configuración
  // 2. El fee debe estar activo (pause = false)
  // 3. Cliente debe estar inactivo (quota_active = false)
  // 4. No debe tener fees C004 (REACTIVATION) pendientes en fee_installments
  
  const feeExists = this.reactivationFeeConfig !== null;
  // El fee está activo si pause es false, undefined, o no existe el campo
  const feeIsActive = !this.reactivationFeeConfig?.pause;
  const isInactive = !this.person.person.quota_active;
  
  // Verificar si tiene fees C004 pendientes en fee_installments (buscar por concept_deduction C004)
  console.log('🔍 Analizando personFees:', {
    total: this.personFees.length,
    fees: this.personFees.map((f: any) => ({
      code_concept: f.fee?.concept_deduction?.code_concept,
      payment_status_code: f.payment_status?.code,
      payment_status_name: f.payment_status?.name,
      manual_deleted: f.manual_deleted,
      due_balance: f.due_balance
    }))
  });
  
  const hasPendingC004 = this.personFees.some((fee: any) => 
    fee.fee?.concept_deduction?.code_concept === 'C004' &&
    (fee.payment_status?.code === 'PaymentPending' || fee.payment_status?.code === 'PEN') &&
    !fee.manual_deleted
  );
  
  console.log('🔍 canGenerateReactivationFee - Validaciones:', {
    feeExists,
    feeIsActive,
    pauseValue: this.reactivationFeeConfig?.pause,
    feeConfig: this.reactivationFeeConfig,
    isInactive,
    quota_active: this.person.person.quota_active,
    hasPendingC004,
    personFeesCount: this.personFees.length,
    result: feeExists && feeIsActive && isInactive && !hasPendingC004
  });
  
  return feeExists && feeIsActive && isInactive && !hasPendingC004;
}

// Genera el fee de reactivación
async generateReactivationFee() {
  try {
    const result = await Swal.fire({
      title: '¿Generar Fee de Reactivación?',
      html: `
        <p>Se generará un fee de reactivación para el cliente:</p>
        <p class="fw-bold">${this.person.person.name} ${this.person.person.lastName}</p>
        <p class="text-muted small">El monto del fee se calculará según la configuración actual.</p>
      `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, generar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33'
    });

    if (!result.isConfirmed) return;

    Swal.fire({
      title: 'Generando fee...',
      text: 'Por favor espere',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    console.log('📞 Llamando a applyReactivationFee con personId:', this.person.person._id);
    const observable = (this._user as any).applyReactivationFee(this.person.person._id);
    const resp: any = await lastValueFrom(observable);
    console.log('📥 Respuesta del backend:', resp);
    Swal.close();

    if (resp.success) {
      await Swal.fire({
        icon: 'success',
        title: '¡Fee generado!',
        html: `
          <p>El fee de reactivación ha sido generado exitosamente.</p>
          <p class="fw-bold">Monto: $${resp.data.amount} USD</p>
          <p class="text-muted small">El cliente debe pagar este fee para reactivar su cupo.</p>
        `,
        confirmButtonText: 'Entendido'
      });

      // Recargar datos
      await this.getPerson();
    } else {
      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: resp.message || 'No se pudo generar el fee de reactivación',
        confirmButtonText: 'Cerrar'
      });
    }
  } catch (error: any) {
    console.error('❌ Error generando fee de reactivación:', error);
    Swal.close();
    await Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error?.error?.message || 'Ocurrió un error al generar el fee de reactivación',
      confirmButtonText: 'Cerrar'
    });
  }
}

// Redirige a la página de pagos
goToPayments() {
  if (!this.person?.person?.code) {
    console.error('No se encontró el código de la persona');
    return;
  }
  
  // Redirigir a la página de pagos del cliente
  this.router.navigate(['/console/person/payments', this.person.person.code]);
}

// Getters para filtrar por estatus
get filteredInstallmentFees() {
  if (!this.resp_paymentsCredits) return [];

  return this.resp_paymentsCredits.filter((fee: any) => {
    const vs = this.getFeeVisualStatus(fee);
    if (this.filterStatus === 'pending') return vs === 'pending';
    if (this.filterStatus === 'completed') return vs === 'complete' || vs === 'awaiting-close';
    if (this.filterStatus === 'disabled') return vs === 'inactive';
    return true;
  });
}

get filteredPersonFees() {
  if (!this.personFees) return [];

  return this.personFees.filter((fee: any) => {
    const vs = this.getFeeVisualStatus(fee);
    if (this.filterStatus === 'pending') return vs === 'pending';
    if (this.filterStatus === 'completed') return vs === 'complete' || vs === 'awaiting-close';
    if (this.filterStatus === 'disabled') return vs === 'inactive';
    return true;
  });
}



}
